import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie';
import TrackApi from './TrackApi';

const CallTrackApi = (pageName,url) => {
  const [cookies, setCookie] = useCookies(['LeadId']);

    const trackData=(id)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": `${pageName} page visit`,
          "mx_Custom_1": `${pageName}`,
          "mx_Custom_2": `Your ${pageName} Note`,
          "mx_CustomObject_81":url
         }
         TrackApi(payloadData);
      }
      useEffect(()=>{
      
    if(cookies && cookies.RelatedProspectId){
      trackData(cookies.RelatedProspectId);
    }
        
      },[])
}

export default CallTrackApi